import { createContext, useRef } from 'react';

export const ScormManagerContext = createContext({});

const ScormManagerProvider = ({ children }) => {
    const scormManagerRef = useRef(null);

    const destroyScormIframe = async () => {
        const scormCloudIframe = scormManagerRef?.current?.contentWindow;
        scormCloudIframe.close();
        scormCloudIframe.location.href = 'about:blank';
    };

    return (
        <ScormManagerContext.Provider
            value={{ destroyScormIframe, scormManagerRef }}
        >
            {children}
        </ScormManagerContext.Provider>
    );
};

export default ScormManagerProvider;
